import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Games from "@/pages/Games";
import LiveGame from "@/pages/LiveGame";
import LiveCompanion from "@/pages/LiveCompanion";
import Watch from "@/pages/Watch";
import WatchGame from "@/pages/WatchGame";
import WhyItMatters from "@/pages/WhyItMatters";
import Ask from "@/pages/Ask";
import Storylines from "@/pages/Storylines";
import HotTakes from "@/pages/HotTakes";
import Highlights from "@/pages/Highlights";
import Teams from "@/pages/Teams";
import Players from "@/pages/Players";
import Cards from "@/pages/Cards";
import Memory from "@/pages/Memory";
import Pricing from "@/pages/Pricing";
import Onboarding from "@/pages/Onboarding";
import Settings from "@/pages/Settings";
import PressBox from "@/pages/PressBox";
import PressBoxLive from "@/pages/PressBoxLive";
import PressBoxInterview from "@/pages/PressBoxInterview";
import PressBoxCommentary from "@/pages/PressBoxCommentary";
import PressBoxPressConference from "@/pages/PressBoxPressConference";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // OAuth session_id arrives in URL fragment — handle synchronously before other routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/onboarding" element={<ProtectedRoute requireOnboarded={false}><Onboarding /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/games" element={<ProtectedRoute><Games /></ProtectedRoute>} />
      <Route path="/games/:id" element={<ProtectedRoute><LiveGame /></ProtectedRoute>} />
      <Route path="/live" element={<ProtectedRoute><LiveCompanion /></ProtectedRoute>} />
      <Route path="/watch" element={<ProtectedRoute><Watch /></ProtectedRoute>} />
      <Route path="/watch/:id" element={<ProtectedRoute><WatchGame /></ProtectedRoute>} />
      <Route path="/why-it-matters" element={<ProtectedRoute><WhyItMatters /></ProtectedRoute>} />
      <Route path="/ask" element={<ProtectedRoute><Ask /></ProtectedRoute>} />
      <Route path="/storylines" element={<ProtectedRoute><Storylines /></ProtectedRoute>} />
      <Route path="/hot-takes" element={<ProtectedRoute><HotTakes /></ProtectedRoute>} />
      <Route path="/highlights" element={<ProtectedRoute><Highlights /></ProtectedRoute>} />
      <Route path="/teams" element={<ProtectedRoute><Teams /></ProtectedRoute>} />
      <Route path="/players" element={<ProtectedRoute><Players /></ProtectedRoute>} />
      <Route path="/cards" element={<ProtectedRoute><Cards /></ProtectedRoute>} />
      <Route path="/memory" element={<ProtectedRoute><Memory /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/press-box" element={<ProtectedRoute><PressBox /></ProtectedRoute>} />
      <Route path="/press-box/interview" element={<ProtectedRoute><PressBoxInterview /></ProtectedRoute>} />
      <Route path="/press-box/commentary" element={<ProtectedRoute><PressBoxCommentary /></ProtectedRoute>} />
      <Route path="/press-box/press-conference" element={<ProtectedRoute><PressBoxPressConference /></ProtectedRoute>} />
      <Route path="/press-box/:gameId" element={<ProtectedRoute><PressBoxLive /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <AppRouter />
            <Toaster />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
